// Copyright (c) 2022, Comsearch, Inc., All rights reserved

import setUserAndAuthToken from 'redux/modules/user/thunks/setUserAndAuthToken'

const syncAuthenticationBroadcastChannelWithRedux = userUpdate => (dispatch, getState) => {
  const { userId } = userUpdate.user

  const user = getState().user

  // only update this tab's authentication and user info if the broadcast channel emitted an update
  // event for the exact same user as is logged in for this tab.
  if (user.get('userId') === userId) {
    dispatch(setUserAndAuthToken(userUpdate))
  }
}

export default syncAuthenticationBroadcastChannelWithRedux
